import { useDialog } from "./DialogProvider";
import { Button, DialogContent, DialogTitle } from "@material-ui/core";
import * as requestFunctions from "../../utils/functions/RequestFunctions";
import mynOberStore from "../../utils/flux/MynOberStore";
import DialogError from "./DialogError";
import React from "react";
import DialogSuccess from "./DialogSuccess";
import withIntl from "../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import DialogOk from "./DialogOk";

const useStyles = makeStyles((theme) => ({
  button: {
    width: "240px",
    margin: "8px",
  },
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

function DialogWaiterRequest(props) {
  const classes = useStyles();
  const [openDialog, closeDialog] = useDialog();

  const onSendWaiterRequestClicked = () => {
    closeDialog();
    requestFunctions
      .checkLocation()
      .then((distance) => {
        requestFunctions
          .sendWaiterRequest(mynOberStore.merchant, distance)
          .then(() => {
            openDialog({
              children: <DialogSuccess content={"alert_text_success_waiter_request"} />,
            });
          })
          .catch((text) => {
            openDialog({ children: <DialogError content={text} /> });
          });
      })
      .catch((error) => {
        if (error.code === 1) {
          openDialog({
            children: <DialogOk title={"alert_title_location_denied"} content={"alert_text_permission_location"} />,
          });
        } else {
          openDialog({
            children: <DialogOk title={"alert_title_failed"} content={"alert_text_failed_location"} />,
          });
        }
      });
  };

  return (
    <>
      <DialogTitle>{props.intl.formatMessage({ id: "alert_title_waiter_request" })}</DialogTitle>
      <DialogContent>
        <h3>{props.intl.formatMessage({ id: "alert_text_sure" })}</h3>
        <div className={classes.div}>
          <Button className={classes.button} variant={"outlined"} onClick={onSendWaiterRequestClicked}>
            {props.intl.formatMessage({ id: "button_yes" })}
          </Button>
          <Button className={classes.button} variant={"outlined"} onClick={closeDialog}>
            {props.intl.formatMessage({ id: "button_cancel" })}
          </Button>
        </div>
      </DialogContent>
    </>
  );
}

export default withIntl(DialogWaiterRequest);
